import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import { Link } from 'react-router-dom';
import {print} from 'react-icons-kit/fa/print';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {cross} from 'react-icons-kit/icomoon/cross';
import {minus} from 'react-icons-kit/icomoon/minus';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import ModalSingleValidation from '../../../validation_donation/components/ModalSingleValidation';
import WaitingModal from '../../../generics/WaitingModal';
import moment from 'moment';

var Config = require('../../../../config');

class TableItems extends Component {

  constructor(props, context) {
    super(props, context);
    this.openModalValidation = this.openModalValidation.bind(this);
    this.onUpdate = this.onUpdate.bind(this);

    this.state = {
      columns:[],
      lab_sections:[],
      disableGroupRh:true
    };
  }

  componentDidMount() {
    this.props.onRef(this);

    var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));
    user_task.map((user)=>{
      if(user.type !== undefined){
        if(user.type==='PRINT_RESULTS'){
          this.setState({
            disableGroupRh: false
          })
        }
      }
    })

    fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=SAMPLE_RESULTS',{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(response => {
      if(response.ok){
        return response.json();
      }else{
        response.text().then((msg)=>{
          swal('Error', msg, 'error');
        });
      }       
    }).then(response => {
      if(response !== undefined){

          this.setState({ columns: response });
      }
    });

    fetch(Config.default.apiGateway.URL+'lab_sections/byUser?health_facilities_id='+sessionStorage.getItem("health_facilities_id"), {
      method : 'get',
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'        : 'application/json',
        'Content-Type'  : 'application/json'
      })
    })
    .then(res => {
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error', error, 'error');
            });
        }
    })
    .then(response => {
        this.setState({
          lab_sections: response
        });
    })
  }

  showColumn(column_name){
    for(var i =0; i < this.state.columns.length;i++){
      if(this.state.columns[i]=== column_name){
            return false;
        }
    }

    return true;
  }

  componentWillUnmount() {
    this.props.onRef(null)
  }


  filter(row){ 
    var res = true;

    if(row !== null){
      if(
        row.donor !== null &&
        row.number !== null &&
        row.sample_type !== null &&
        row.timestamp !== null 
      ){
        if(
          row.donor.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
          row.number.toString().indexOf(this.props.filterText.toUpperCase()) !== -1 ||
          row.sample_type.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
          row.timestamp.toString().indexOf(this.props.filterText.toUpperCase()) !== -1 
          
        ){
          res = true;
        }else{
          res = false;
        }
      }
    }

    return res;

  }

  singleValidation(e, section, item){
    e.preventDefault();
    this.single_validation.handleShow(0, section.lab_sections_id, section.name, item.id);
  }

  getIconSectionColor(sections_color, lab_section_id){
    for(var i=0;i < sections_color.length;i++){
      if(sections_color[i].lab_section_id === lab_section_id){
        return sections_color[i].color;
      }
    }

    return "";
  }

  openModalValidation(e, validate, sample_id, sections){
    e.preventDefault();
    if(validate === "PENDING"){
      
      var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
      var obj = [];
      var names = "";
      lab_sections.map((s)=>{
        if(s.validate_results){
          var indexSection = sections.findIndex((obj => obj.lab_section_id === s.lab_sections_id));

          if(indexSection !== -1){
            obj.push(s.lab_sections_id);
            
            names += sections[indexSection].lab_section_name+', '
          }
           
        }
      })
      names = names.slice(0, (names.length - 2));
   
      if(obj.length < lab_sections.length){
         swal({
              title: '¿Está seguro?',
              text: 'Las secciones permitidas para validar son '+names,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: '¡Si, Validar!',
              cancelButtonText: '¡No, Cancelar!',
              closeOnConfirm: true,
              closeOnCancel: true
          }, function (isConfirm) {
              if (isConfirm) {
                  
                  this.waiting_modal.handleShow("Validando Resultados...");
                  setTimeout(function(){
                    this.validateSection(sample_id, obj);
                  }.bind(this), 1000);
                  
              }
          }.bind(this));
      
      }else if(obj.length === lab_sections.length){
        
        this.waiting_modal.handleShow("Validando Resultados...");
        setTimeout(function(){
          this.validateSection(sample_id, obj);
        }.bind(this), 1000);
      }

    }else{
      swal('¡Error!', '¡No hay resultados pendientes por validar!', 'error');
    }
   
  }

  validateSection(sample_id, sections){
    
    fetch(Config.default.apiGateway.URL+'samples/validate_sample?sample_id='+sample_id,{
      method :'POST',
      body:JSON.stringify(sections),
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'    : 'application/json',
        'Content-Type'  : 'application/json'
      }) 
    })
    .then(res => {
        this.waiting_modal.handleClose();
        if(res.ok){
          return res.json();
        }else{
          res.text().then(function(error) {
            swal('¡Error!', error, 'error');
          });
        }
    })
    .then(response => {
      if(response !== undefined){
        var msg = "<table class='table' style='text-align:left;'>"+
                  "<thead>"+
                    "<tr>"+
                      "<th style='text-align:center'>Sección</th>"+
                      "<th style='text-align:center'>Estatus</th>"+
                      "<th style='text-align:center'>Mensaje</th>"+
                    "</tr>"+
                  "</thead>"+
                  "<tbody>";
        for(var i =0;i < response.length;i++){
          msg += "<tr>"+
                    "<td>"+response[i].lab_section+"</td>"+
                    "<td>"+response[i].status.toUpperCase()+"</td>"+
                    "<td>"+response[i].message+"</td>"+
                  "</tr>";
        }
              
        msg += "</tbody></table>";
        
        swal({
          title: "Proceso Terminado",
          html:true,
          text: msg,
          type: 'success',
          //customClass: 'swal-wide',
        }, function (isConfirm) {
            if (isConfirm) {
              this.props.refresh();
            }else{
              return false;
            }
        }.bind(this));
      }
    })
  }

  onUpdate(e, id, group_test){
    if(group_test === null){
      this.props.history.push('/sample_results/edit/'+id+'/0/0');
    }else{
      this.props.history.push('/sample_results/edit/'+id+'/0/'+group_test.id);
    }
    
  }
  //Contenido de la tabla
  render () {
    const { t } = this.props;
    return (
      <div>
        <Table responsive hover>
          <thead>
            <tr>
              <th hidden={this.showColumn('SAMPLE_NUMBER')}>No. Muestra</th>
              <th hidden={this.showColumn('DONOR')}>Donador</th>
              <th hidden={this.showColumn('REGISTER_DATE')}>Fecha Registro</th>
              <th hidden={this.showColumn('SAMPLE_TYPE')}>Tipo Muestra</th>
              {
                this.state.lab_sections.map((item, index) =>{ 
                  return <th key={index}>{item.code}</th>
                }) 
              }
              <th hidden={this.showColumn('VALIDATED')}>Validado</th>
              <th width={125}></th>
            </tr>
          </thead>
          <tbody>
        
          {this.props.items.map( (obj, index) => (
              this.filter(obj.item) === true? 
              <tr key={index} >
                <td hidden={this.showColumn('SAMPLE_NUMBER')}>{obj.item.number}</td>
                <td hidden={this.showColumn('DONOR')}>{obj.item.donor}</td>
                <td hidden={this.showColumn('REGISTER_DATE')}>{moment(obj.item.timestamp).format('DD/MM/YYYY HH:mm')}</td>
                <td hidden={this.showColumn('SAMPLE_TYPE')}>{obj.item.sample_type}</td>
                {
                  this.state.lab_sections.map((section, index) =>{ 
                    return  <td key={"td_"+section.name}>
                              <a href="" title={section.name} onClick={(e) => this.singleValidation(e, section, obj.item)} 
                              style={{color:this.getIconSectionColor(obj.sections_color,section.lab_sections_id)}}>
                                <SvgIcon size={25} icon={clipboard}/>
                              </a>
                            </td>
                  }) 
                }
                <td hidden={this.showColumn('VALIDATED')} style={{textAlign:"center"}} align="center">
                   {obj.item.validation==="ACCEPTED"?
                      <button style={{fontSize:".5em", textAlign:"center"}} 
                        onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.id, obj.sections_color)} align="center" 
                        className="btn btn-success" type="button">
                        <SvgIcon icon={checkmark}/>
                      </button>
                    :obj.item.validation==="REJECT" || obj.item.validation==="DISCREPANT"?
                      <button style={{fontSize:".5em"}} className="btn btn-danger" type="button" 
                        onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.id, obj.sections_color)}>
                        <SvgIcon icon={cross}/>
                      </button>
                    : <button style={{fontSize:".5em",backgroundColor:"orange",color:"white"}} className="btn" 
                        type="button" onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.id, obj.sections_color)}>
                        <SvgIcon icon={minus}/>
                      </button>
                  }
                </td>
                <td width={135}>
                  <FloatingActionButton className="action-btn" iconStyle={{height: 33, width: 33}} mini={true} 
                    disabled={!this.props.task_sample_results.update}
                    style={{marginLeft:"5px"}} onClick={(e)=>this.onUpdate(e, obj.item.id, obj.item.group_test)}>
                    <SvgIcon icon={pencil2}/>
                  </FloatingActionButton>

                  {/*<FloatingActionButton iconStyle={{height: 33, width: 33}} onClick={(e) => this.laboratory_print(e, obj.item)}
                      mini={true} style={{marginLeft:"5px"}}>
                    <SvgIcon icon={print}/>
                  </FloatingActionButton>*/}
                </td>
              </tr>:null
              ))}
          </tbody>
        </Table>
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
        <ModalSingleValidation {...this.props} onRef={ref => (this.single_validation = ref)} refresh={this.props.refresh} state={this.props.state}/>
      </div>
    );
  }
}

export default translate('translations')(TableItems)